var makeString = require('./makeString');

module.exports = function escapeRegExp(str) {
  return makeString(str).replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/helper/escapeRegExp.js
// module id = 801
// module chunks = 0